const { Ability } = require("@casl/ability");

const defineAbilitiesForUser = (user) => {
  const { permissions } = user;
  return new Ability(permissions);
};

module.exports = { defineAbilitiesForUser };
